@if (!authState().isAuthenticated) {
<div class="login-container">
  <mat-card class="login-card">
    <a class="app-title" aria-label="zav cms">
      <div class="logo"></div>
    </a>

    <form [formGroup]="loginForm" autocomplete="off" novalidate>
      <mat-form-field>
        <mat-label>E-Mail Adresse</mat-label>
        <input matInput formControlName="email" (keydown.enter)="sendLogin()">
      </mat-form-field>

      <mat-form-field>
        <mat-label>Passwort</mat-label>
        <input matInput type="password" formControlName="password" (keydown.enter)="sendLogin()">
      </mat-form-field>

      <button mat-raised-button color="primary" (click)="sendLogin()">Login</button>
    </form>
  </mat-card>
</div>
}